import React from "react";
import styles from "./MatchedSSNEINClients.module.css";
import { Modal } from "react-bootstrap";
import CygnusGrid from "../../../../reusable_components/CygnusGrid/CygnusGrid";
import alertModalStyles from "../../../../../Reusables/components/AlertModal/AlertModal.module.css";
import CustomButton from "../../../../../pages/reusable_components/custom_button_component/Button";

interface MatchedSSNEINClientsModalProps {
  show: boolean;
  onHide: () => void;
  matchedClients: MatchedSSNEINClient[];
  setOnDemandValidation?: (state: boolean) => void;
  setContinueSavingClient: (state: boolean) => void;
  handleSaveandNext?: () => void;
}

interface MatchedSSNEINClient {
  ClientMasterId: string;
  ClientId: number;
  ClientName: number;
  BusinessUnit: number;
  MatchType: number;
}

const recipientColumnDefs = [
  {
    headerName: "ClientId",
    field: "ClientId",
    flex: 1,
    filter: false,
    sortable: false,
  },
  {
    headerName: "Client Name",
    field: "ClientName",
    flex: 1,
    filter: false,
    sortable: false,
  },
  {
    headerName: "Business Unit",
    field: "BusinessUnit",
    flex: 1,
    filter: false,
    sortable: false,
  },
  {
    headerName: "Match Type",
    field: "MatchType",
    width: 130,
    filter: false,
    sortable: false,
  },
];

/**
 * MatchedSSNEINClients Component
 */
const MatchedSSNEINClients: React.FC<MatchedSSNEINClientsModalProps> = ({
  show,
  onHide,
  matchedClients,
  setOnDemandValidation,
  setContinueSavingClient,
  handleSaveandNext
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      keyboard={false}
      dialogClassName={alertModalStyles.dialog}
      contentClassName={alertModalStyles.content}
      backdropClassName={alertModalStyles.backdrop}
      aria-labelledby="recipients-modal"
    >
      <Modal.Header closeButton className={alertModalStyles.header}>
        <Modal.Title className={alertModalStyles.message}>
          Matched Clients with SSN/EIN
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={alertModalStyles.body}>
        <div className={styles.gridWrapper}>
          <CygnusGrid
            columnDefs={recipientColumnDefs}
            fetchData={async () => ({
              records: matchedClients,
              totalCount: matchedClients.length,
            })}
            cachedData={matchedClients}
            rowModelType="clientSide"
            dataIdentifier="Sequence"
            rowSelection={undefined}
            floatingFilters={false}
          />
        </div>
      </Modal.Body>

      <Modal.Footer className={alertModalStyles.footer}>
        <CustomButton
          key={`cancelButton`}
          content={"Cancel"}
          progress={false}
          type={"warning"}          
          onclick={() => { onHide() }}
        />
        <CustomButton
          key={`continueButton`}
          content={"Continue"}
          progress={false}
          type={"warning"}          
          onclick={() => {
            if (setOnDemandValidation) {
              setOnDemandValidation(true);
            } else if (handleSaveandNext) {
              handleSaveandNext();
            }
            setContinueSavingClient(true);
            onHide();
          }}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default MatchedSSNEINClients;
